<template>
  <div>
    <div class="h-content">
      <div class="home-wrapper" id="channel">
        <channel-header></channel-header>

        <nsfw-warning v-if="notSafeForWorkWarning" :text="text"></nsfw-warning>

        <router-view v-else></router-view>
      </div>
    </div>

    <!--<el-col class="guest_main" v-else :span="20" :offset="2">
                <div class="home-wrapper-stop" id="channel-stop">
                    <channel-header></channel-header>

                    <nsfw-warning v-if="notSafeForWorkWarning" :text="text"></nsfw-warning>

                    <router-view v-else></router-view>
                </div>
    </el-col>-->

    <div class="h-sidebar">
      <community-side-bar></community-side-bar>
    </div>
  </div>
</template>

<script>
import ChannelHeader from "../components/ChannelHeader.vue";
import NsfwWarning from "../components/NsfwWarning.vue";
import CommunitySideBar from "../components/sidebars/CommunitySideBar";
import ChannelSubmissions from "../components/ChannelSubmissions.vue";
import Helpers from "../mixins/Helpers";

export default {
  mixins: [Helpers],

  components: {
    ChannelSubmissions,
    ChannelHeader,
    NsfwWarning,
    CommunitySideBar
  },

  computed: {
    notSafeForWorkWarning() {
      return (
        Store.page.channel.temp.nsfw &&
        !Store.settings.feed.include_nsfw_submissions
      );
    },

    text() {
      return this.isLoggedIn
        ? "This channel contains NSFW content which can not be displayed according to your personal settings."
        : "This channel contains NSFW content which can not be displayed to guests.";
    }
  }
};
</script>
<style scoped>
.guest_main {
  margin-top: 45px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Channel.vue